import React from "react";

import clsx from "clsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "@material-ui/core";

import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import {
  setSidebarToggle,
  setSidebarToggleMobile,
  userSelector,
  sceneSelector,
} from "../../core";

import projectLogo from "../../assets/Parent_Parties_Logo.png";

const SidebarHeader = (props) => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const {
    sidebarToggleMobile,
    setSidebarToggleMobile,
    sidebarToggle,
    setSidebarToggle,
  } = props;

  return (
    <>
      <div className="app-sidebar--header">
        <div className="app-sidebar-logo">
          <NavLink
            to={
              props.user && props.scene
                ? props.user.checkleSupport
                  ? "/support"
                  : props.scene.type === "none"
                  ? `/dashboard`
                  : `/dashboard/${
                      props.scene.type === "district" ? "d" : "s"
                    }/${props.scene.id}`
                : `/dashboard`
            }
            title="Go to Dashboard"
            className="app-sidebar-logo"
          >
            <div
              className="app-sidebar-logo--icon"
              style={{ backgroundColor: "#fff" }}
            >
              <img alt="Parent Parties Logo" src={projectLogo} />
            </div>
            <div className="app-sidebar-logo--text">
              <b style={{ textTransform: "none" }}>Parent Parties Engage</b>
            </div>
          </NavLink>
        </div>
        <Tooltip title="Collapse sidebar" placement="right" arrow>
          <Button
            onClick={toggleSidebar}
            className="btn btn-sm collapse-sidebar-btn"
          >
            <FontAwesomeIcon icon={["far", "dot-circle"]} size="lg" />
          </Button>
        </Tooltip>
        <Button
          className={clsx(
            "navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn",
            { "is-active": sidebarToggleMobile }
          )}
          onClick={toggleSidebarMobile}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </Button>
        <Tooltip title="Expand sidebar" placement="right" arrow>
          <Button
            onClick={toggleSidebar}
            className="expand-sidebar-btn btn btn-sm"
          >
            <FontAwesomeIcon icon={["fas", "arrows-alt-h"]} />
          </Button>
        </Tooltip>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
  user: userSelector(state),
  scene: sceneSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
  setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);
